import React from 'react';

const SinglePageItemText = ({ title, value }) => {
  return (
    <div className="single-page-item">
      <h4>
        {title}
      </h4>
      <p>
        {value || "N/A"}
      </p>
    </div>
  )
}

export default SinglePageItemText;